export default __webpack_public_path__ + "static/media/on.f16f45a3.mp3";